interface LoadingScreenProps {
  uploadProgress: number;
  uploadStatus: string;
}

export const LoadingScreen = ({ uploadProgress, uploadStatus }: LoadingScreenProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="bg-white border border-gray-200 shadow-sm rounded-2xl p-12 max-w-2xl w-full text-center">
        <div className="animate-spin w-16 h-16 border-4 border-wppBlue border-t-transparent rounded-full mx-auto mb-6"></div>
        <h2 className="text-2xl font-semibold mb-4">Analyzing Assets...</h2>

        <div className="mb-4">
          <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden mb-2">
            <div
              className="h-full bg-gradient-to-r from-[#93DFE4] to-[#10B981] transition-all duration-300"
              style={{ width: `${uploadProgress}%` }}
            />
          </div>
          <p className="text-sm text-gray-600 break-words px-4">{uploadStatus}</p>
        </div>

        <p className="text-xs text-gray-400">{uploadProgress}%</p>
      </div>
    </div>
  );
};
